import axios from "axios";

export default axios.create({
    baseURL: "https://react-http-29978-default-rtdb.firebaseio.com/"
});